// extracted by mini-css-extract-plugin
export default {"UtilityBoxContainer":"index_UtilityBoxContainer__3mpb4","UtilityBoxHome":"index_UtilityBoxHome__2AtE_","UtilityBox":"index_UtilityBox__xZeh- container_verticalSpaced__5DnrN"};